import React, { useEffect, useState } from 'react'

import companyServices from '../../company/companyServices';
import { Email, Phone } from '@mui/icons-material';
import voucherServices from '../voucherServices';

import { useAppData } from '../../../../../../context/AppDataContext';
import partyServices from '../../party/partyServices';
import SelectPartyAddress from '../../party/components/SelectPartyAddress';
import { useAlert } from '../../../../../../context/AlertContext';
import VoucherInlineEdit from '../inline/VoucherInlineEdit';

function SalesVoucherHeader({voucherDetails, companyDetails,setCompanyDetails,partyDetails,setPartyDetails, callBack, isPrinting }) {

    

    const [partyLoading,setPartyLoadingStatus] = useState(false);
    const [companyLoading,setCompanyLoadingStatus] = useState(false);
    const {getMasterLabel} = useAppData();
    

    const getPartyDetails = () =>{
        setCompanyLoadingStatus(true);
        setPartyDetails(null);
        partyServices.getById(voucherDetails.partyId).then(res=>{
            setPartyDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setCompanyLoadingStatus(false);
        })
    }
    const getComapnyDetails = () =>{
        setPartyLoadingStatus(true);
        companyServices.getById(voucherDetails.companyId).then(res=>{
            setCompanyDetails(res.data);
        }).catch(error=>{
        }).finally(()=>{
            setPartyLoadingStatus(false);
        })
    }

    useEffect(()=>{
        if(voucherDetails){
            getPartyDetails();
            getComapnyDetails();
        }
    },[voucherDetails])

    const updateShippingAddress = (partyAddress) =>{
        let payload = {
            id:voucherDetails.id,
            shippingAddress : partyAddress.addressString,
        }
        voucherServices.save(payload).then(res=>{
            callBack();
        })
    }

    const updateBillingAddress = (partyAddress) =>{
        let payload = {
            id:voucherDetails.id,
            billingAddress : partyAddress.addressString,
            supplyState:partyAddress.address.supplyState,
        }
        voucherServices.save(payload).then(res=>{
            callBack();
        })
    }


    const {AppAlert} = useAlert();
    const updateVoucherDetails = (payload) =>{
        payload.id = voucherDetails.id;
        console.log(payload);
        voucherServices.save(payload).then(res=>{
            AppAlert("Voucher Details updated");
            callBack();
        }).catch(error=>{
        console.log(error);
        })
    }

    return (
        voucherDetails && companyDetails && partyDetails &&
        <table className='table table-sm table-bordered mb-0' style={{fontSize:12}}>
            <thead>
                <tr>
                    <th className='text-center' colSpan={2}>
                        {voucherDetails.voucherType == "Sale" && "TAX Invoice"}
                        {voucherDetails.voucherType == "DebitNote" && "Debit Note"}
                        {voucherDetails.voucherType == "ChallanOut" && "Delivery Challan"}
                    </th>
                </tr>
                <tr>
                    <td width={"65%"} className='align-top'>
                        <div class="d-flex justify-content-between">
                            <div>
                                <img src={companyDetails.logo} style={{maxHeight:".75in", maxWidth:"1.5in"}} />
                                <div><Email style={{fontSize:14}}/> : {companyDetails.email}</div>
                                <div><Phone style={{fontSize:14}}/> : {companyDetails.phone}</div>
                                <div><span className='fw-bold'>GST : </span>{companyDetails.gst.toUpperCase()}</div>
                            </div>
                            <div className='px-2'>
                                <div>{companyDetails.companyName}</div>
                                <div>{companyDetails.address}</div>
                                <div>{companyDetails.city}, {getMasterLabel("indian-state",companyDetails.state)}, {companyDetails.zip}</div>
                                <div>State : {getMasterLabel("indian-state",companyDetails.state)}</div>
                            </div>
                        </div>
                        <div>
                            
                        </div>
                    </td>
                    <td>
                        <table className='table table-striped table-sm mb-0'>
                            <tbody>
                                <tr>
                                    <td>
                                        {voucherDetails.voucherType == "Sale" && "Invoice #"}
                                        {voucherDetails.voucherType == "DebitNote" && "Debit Note #"}
                                        {voucherDetails.voucherType == "ChallanOut" && "Delivery Challan #"}
                                    </td>
                                    <td>{voucherDetails.voucherNo}</td>
                                </tr>
                                <tr>
                                    <td>Invoice Date</td>
                                    <td>
                                        <VoucherInlineEdit
                                            caption={"Invoice Date"}
                                            field={"voucherDate"}
                                            value={voucherDetails.voucherDate}
                                            callBack={updateVoucherDetails}
                                            isPrinting={isPrinting}
                                            inputType={"date"}
                                        />
                                    </td>
                                </tr>

                                <tr>
                                    <td>Due Date</td>
                                    <td>
                                        <VoucherInlineEdit
                                            caption={"Due Date"}
                                            field={"paymentDueDate"}
                                            value={voucherDetails.paymentDueDate}
                                            callBack={updateVoucherDetails}
                                            isPrinting={isPrinting}
                                            inputType={"date"}
                                        />
                                    </td>
                                </tr>

                                {voucherDetails.refNo && voucherDetails.refNo !== "" && 
                                <tr>
                                    <td>Order/Ref Number</td>
                                    <td>{voucherDetails.refNo}</td>
                                </tr>
                                }
                                
                                {voucherDetails.ewayBillNo && voucherDetails.ewayBillNo !== "" &&
                                <tr>
                                    <td>E Waybill No</td>
                                    <td>{voucherDetails.ewayBillNo}</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td colSpan={2}>
                        <div class="d-flex justify-content-between">

                            {voucherDetails.billingAddress == null ?
                                voucherDetails.status === 1  && <SelectPartyAddress partyId={partyDetails.id} callBack={updateBillingAddress} caption={"Billing Address"} />
                                :
                                <div style={{width:"50%"}} className="hover-container">
                                    <div className='float-end'>
                                        {voucherDetails.status === 1 &&
                                            <SelectPartyAddress partyId={partyDetails.id} callBack={updateBillingAddress} address={voucherDetails.billingAddress} caption={"Billing Address"} />
                                        }
                                    </div>
                                    <div className='fw-bold'>Bill To / Deliver To</div>
                                    
                                    <div style={{ whiteSpace: 'pre-line' }}>{voucherDetails.billingAddress}</div>
                                    {/*<div>{voucherDetails.billingAddress.city}, { getMasterLabel("indian-state",voucherDetails.billingAddress.state) }, {voucherDetails.billingAddress.zip}</div>*/}
                                    {voucherDetails.partyGstin !== "" && voucherDetails.partyGstin !== null &&<div>GST # {voucherDetails.partyGstin.toUpperCase()}</div> }
                                </div>
                            }

                            { voucherDetails.shippingAddress == null ?
                                voucherDetails.status === 1 ? 
                                    voucherDetails.billingAddress && <SelectPartyAddress partyId={partyDetails.id} callBack={updateShippingAddress} caption={"Shipping Address"} />
                                    :
                                    <div style={{width:"50%"}}>
                                        <div className='fw-bold'>Consignee  (Ship to)</div>
                                        <div className='small'>Same as Billing Address</div>
                                    </div>
                                :
                                <div style={{width:"50%"}} className="hover-container">
                                    <div className='float-end'>
                                        {voucherDetails.status === 1 &&
                                            <SelectPartyAddress partyId={partyDetails.id} callBack={updateShippingAddress} address={voucherDetails.shippingAddress} caption={"Shipping Address"} />
                                        }
                                    </div>
                                    <div className='fw-bold'>Consignee  (Ship to)</div>
                                    <div style={{ whiteSpace: 'pre-line' }}>{voucherDetails.shippingAddress}</div>
                                    {/*<div>{voucherDetails.shippingAddress.city}, { getMasterLabel("indian-state",voucherDetails.shippingAddress.state) },, {voucherDetails.shippingAddress.zip}</div> */}
                                </div>
                            }
                            
                        </div>
                    </td>
                    
                </tr>
            </thead>
        </table>
    )
}

export default SalesVoucherHeader